import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";
import Slideshow from "../../assets/Slideshow/Slideshow";
import "./SchoolProjects.css";

import fontysmarketing1 from "../../assets/Images/fontysmarketing/1.png"
import fontysmarketing2 from "../../assets/Images/fontysmarketing/2.jpg"
import fontysmarketing3 from "../../assets/Images/fontysmarketing/3.jpg"
import fontysmarketing4 from "../../assets/Images/fontysmarketing/4.jpg"
import fontysmarketing5 from "../../assets/Images/fontysmarketing/5.png"
import fontysmarketing6 from "../../assets/Images/fontysmarketing/6.png"
import fontysmarketing7 from "../../assets/Images/fontysmarketing/7.jpg"
import fontysmarketing8 from "../../assets/Images/fontysmarketing/8.JPG"

import fontysmarketing9 from "../../assets/Videos/2.mp4"





const FontysMarketingCampaign = () => {
  // Replace with your real images later (posters, Lumi mascot, Arduino setup, final event pics, etc.)
  const images = [fontysmarketing1,fontysmarketing2,fontysmarketing3,fontysmarketing4,fontysmarketing5,fontysmarketing6,fontysmarketing7,fontysmarketing9,fontysmarketing8];

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="page-container">
      <Navbar />

      <div className="content-lo1-headings">
        <h1>Fontys Marketing Campaign</h1>
        <p>
          A marketing campaign project for Fontys to promote the new <b>Virtual Production</b> minor,
          using cat memes, interactive posters, and a 3D mascot to engage students.
        </p>
      </div>

      <div className="line"></div>

      <div className="breadcrumb-wrap" style={{ padding: "0.1rem 7.5rem" }}>
        <BreadcrumbHeader />
      </div>

      <div className="content-lo1">
        <div className="tweekracht-layout">
          {/* LEFT: Case Study Content */}
          <div className="tweekracht-left">
            {/* Quick nav / anchors */}
            <div className="tweekracht-anchors">
              <button onClick={() => scrollToId("overview")}>Overview</button>
              <button onClick={() => scrollToId("audience")}>Audience</button>
              <button onClick={() => scrollToId("concept")}>Concept</button>
              <button onClick={() => scrollToId("process")}>Process</button>
              <button onClick={() => scrollToId("deliverables")}>Deliverables</button>
              <button onClick={() => scrollToId("reflection")}>Reflection</button>
            </div>

            <section id="overview" className="tweekracht-section">
              <h2>Project Overview</h2>
              <p>
                This client project was developed for <b>Fontys Marketing</b>, with the goal of promoting
                a new minor called <b>Virtual Production</b>. The challenge was that the minor was still
                relatively unknown, so the campaign needed to stand out and feel authentic to students.
              </p>
              <p>
                Our group worked on campaign strategy, research, and the creation of both digital and
                physical promotional materials. My contributions focused on combining <b>design + tech</b>
                to create a campaign that students would actually notice and interact with.
              </p>
            </section>

            <section id="audience" className="tweekracht-section">
              <h2>Target Audience</h2>
              <p>
                Since the campaign promotes a Fontys minor, the primary target audience is <b>students</b>.
                As a student myself, I could relate to how students consume information: quickly, visually,
                and often while multitasking. That helped me design materials that feel more natural and less
                like “traditional advertising”.
              </p>
            </section>

            <section id="concept" className="tweekracht-section">
              <h2>Campaign Concept: Cat Memes</h2>
              <p>
                We chose <b>cat memes</b> as the campaign theme because they are widely recognizable, easy
                to understand, and naturally shareable among students. The goal was to use humor to trigger
                an emotional response (amusement/joy), making the campaign more memorable in a space where
                students see a lot of information every day.
              </p>
              <p>
                By pairing the meme style with a clear message about the Virtual Production minor, we aimed
                to make something that feels unique, authentic, and student-friendly.
              </p>
            </section>

            <section className="tweekracht-section">
              <h2>Project Snapshot</h2>
              <div className="tweekracht-snapshot">
                <div className="snapshot-item">
                  <span className="snapshot-label">Client</span>
                  <span className="snapshot-value">Fontys Marketing</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">Goal</span>
                  <span className="snapshot-value">Promote the Virtual Production minor</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">Audience</span>
                  <span className="snapshot-value">Fontys students</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">My Focus</span>
                  <span className="snapshot-value">Posters, 3D mascot, interactive 3D poster (Arduino)</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">Tools</span>
                  <span className="snapshot-value">Figma, Illustrator, Blender, 3D printing, Arduino</span>
                </div>
              </div>
            </section>

            <section id="process" className="tweekracht-section">
              <h2>Research & Process</h2>

              <h3>Understanding the Minor</h3>
              <p>
                We started with basic research to understand what Virtual Production is and how to explain it
                in a way that makes sense to students. From this, we shaped the direction of our messaging:
                Virtual Production combines creative work with technology, allowing filmmakers to change environments
                and surroundings digitally during production.
              </p>

              <h3>Client Meeting</h3>
              <p>
                We scheduled a meeting with the client to clarify expectations and success criteria. The client also
                provided campaign assets and helped us understand what Fontys needed from the campaign.
              </p>

              <h3>Interviews</h3>
              <p>
                As a group, we prepared interview questions and conducted interviews with students and mentors connected
                to the minor. This helped us validate what students care about (skills, tools, project type, vibe, and
                career relevance) and how to position the minor clearly.
              </p>

              <h3>My Assigned Research Focus</h3>
              <p>
                One of the key questions I focused on was: <b>How do we reach students who are genuinely passionate about this minor?</b>
                This pushed me to design campaign elements that feel native to student culture and encourage interaction
                (humor + visual impact + physical experience).
              </p>
            </section>

            <section id="deliverables" className="tweekracht-section">
              <h2>Key Deliverables</h2>

              <h3>Concept Posters</h3>
              <p>
                Our group explored multiple poster concepts first. Everyone created their own version, then we compared ideas
                and combined the strongest elements into one final direction. We used <b>Figma</b> to collaborate, iterate quickly,
                and refine the layout together.
              </p>

              <h3>Final Poster Design</h3>
              <p>
                I created campaign posters using the cat meme theme while keeping a clear connection to Virtual Production.
                During an observation at <b>Pixel Playground</b>, I collected photos and textures that matched the VP vibe.
                One of my photos became the base image for the poster, which I edited in <b>Adobe Illustrator</b> and combined with
                the meme-style elements.
              </p>

              <h3>3D Poster + Arduino Interaction</h3>
              <p>
                Together with Adib, I explored how to make our promotion more interactive. We created a 3D poster by combining
                a physical 3D-printed cat figure with a poster layout. We then integrated an <b>Arduino</b> setup (ultrasonic sensor
                + speaker) so that when someone walks by, it triggers a cat sound. The goal was to turn a poster into an experience:
                surprising, funny, and attention-grabbing.
              </p>

              <h3>3D Mascot: “Lumi”</h3>
              <p>
                Based on feedback from our mentor Jan, I developed an original 3D cat mascot named <b>Lumi</b> (inspired by our studio
                name, Octolume). I sketched the concept and used a teammate’s sketch as the main reference. With guidance from my teacher
                Chris, I modeled Lumi in <b>Blender</b> using a low-poly style to connect it visually to Pixel Playground and make it easier
                to print and use in physical materials.
              </p>
              <p>
                Lumi was created to replace a generic placeholder model, making the campaign more original and “ours”. Even though the mascot
                wasn’t fully finished by the final event, I still showcased how it would strengthen the interactive poster concept.
              </p>
            </section>

            <section id="reflection" className="tweekracht-section">
              <h2>What Did I Learn?</h2>
              <p>
                This project helped me understand how strategy and creativity work together in marketing. I learned that humor can be a serious
                tool when used correctly—cat memes made the campaign feel relatable, increased engagement, and improved memorability.
              </p>
              <p>
                I also learned how to combine design and technology to create interactive experiences. By working with 3D printing and Arduino,
                I started thinking beyond “a poster as a visual” and more as an experience that sparks curiosity and action (like scanning a QR code).
              </p>
              <p>
                Finally, collaborating through Figma and iterating based on feedback taught me how to refine ideas quickly while keeping brand
                consistency and a clear message.
              </p>
            </section>
          </div>

          {/* RIGHT: Sticky Slideshow */}
          <aside className="tweekracht-right">
            {images.length > 0 ? (
              <Slideshow images={images} />
            ) : (
              <div className="slideshow-placeholder">
                <p>Slideshow Placeholder</p>
                <p>Add images to the images array to display slideshow</p>
              </div>
            )}

            <div className="tweekracht-caption">
              <p>
                
              </p>
            </div>
          </aside>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FontysMarketingCampaign;
